export const UPDATE_PROCESS_STATEMENT_RTF_SUCCESS = 'UPDATE_PROCESS_STATEMENT_RTF_SUCCESS';

export const updateProcessStatementRtfSuccess = ({ rtfTemplate }) => ({
    type: UPDATE_PROCESS_STATEMENT_RTF_SUCCESS,
    payload: { rtfTemplate },
});
